<template>
  <Stack class="welcome-main">
    <Stack gap="0">
      <Subtitle>Client Portal</Subtitle>
      <Title>Welcome {{ clientPortalStore.clientName }}</Title>
    </Stack>

    <!-- Logged In Content -->
    <template v-if="clientPortalStore.isLoggedIn">
      <Stack
        gap="2"
      >
        <p class="advisor-message">
          Your financial advisor
          <strong>{{ clientPortalStore.advisorName }}</strong>, is requesting documents from you.
        </p>

        <p class="guidance-text">
          This <strong>Smart Secure Document Portal</strong>
          is designed to help you gather your documents and securely upload them to your advisor.
        </p>
      </Stack>

      <Buttons>
        <Button
          v-if="clientPortalStore.processComplete"
          size="5"
          variant="success"
          @click="emit('finish')"
        >
          Finish
        </Button>
        <Button
          v-else
          size="5"
          variant="primary"
          @click="emit('start')"
        >
          Get Started
        </Button>
      </Buttons>
    </template>

    <!-- Logged Out Preview Content -->
    <template v-else>
      <Stack
        gap="2"
      >
        <p class="advisor-message">
          <strong>{{ clientPortalStore.advisorInfo?.name }}</strong> has invited you to access your secure document portal.
        </p>

        <p class="guidance-text">
          Please log in or create an account to get started.
        </p>
      </Stack>

      <!-- Auth Actions -->
      <Buttons>
        <Button
          v-if="clientPortalStore.clientInfo?.user?.client_has_password"
          variant="primary"
          size="5"
          @click="clientPortalStore.requestLoginRedirect()"
        >
          Log In to Access
        </Button>
        <Button
          v-else
          variant="primary"
          size="5"
          @click="clientPortalStore.handleRedirectToSignup()"
        >
          Set Up Your Account
        </Button>
      </Buttons>
    </template>
  </Stack>
</template>

<script setup>
import { Buttons, Button, Stack, Subtitle, Title } from '@stakeui';
import { watch } from 'vue';
import { useClientPortalStore } from '@frontend/ui/stores/clientPortalStore';

const clientPortalStore = useClientPortalStore();

const emit = defineEmits(['start', 'finish']);

watch(
    () => clientPortalStore.shouldRedirectLogin,
    should => {
      if (!should) return;

      clientPortalStore.clearLoginRedirect?.();

      const query = new URLSearchParams({
        entity: clientPortalStore.currentEntityId || '',
        advisor: clientPortalStore.advisorSlug || '',
        firm: clientPortalStore.firmSlug || '',
      }).toString();

      window.location.assign(`/account/client-login/?${query}`);
    },
);

</script>
